<template>
  <div id="noon-form-hierarchical-select">
    <vs-row vs-w="12">
      <vs-col vs-justify="flex-start" vs-align="center" vs-w="6">
        <div class="aisea-text-14-400-dark-gray">{{ form.label }}</div>
        <treeselect
          v-model="selectedValue"
          :multiple="false"
          :disable-branch-nodes="true"
          :options="options"
          :searchable="false"
          :clearable="false"
          placeholder=""
        >
          <label
            :class="{ 'alert-text': node.raw.isAlert }"
            slot="option-label"
            slot-scope="{ node }"
          >
            {{ node.label }}
          </label>
          <div
            :class="{ 'alert-text': node.raw.isAlert }"
            slot="value-label"
            slot-scope="{ node }"
          >
            {{ node.raw.label }}
          </div>
        </treeselect>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import Treeselect from "@riophae/vue-treeselect";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],
  props: {
    form: { type: Object, required: true },
    value: { required: false },
  },
  data() {
    return {
      options: [],
      selectedValue: null,
      parentSelected: null,
      childSelected: null,
      parentSelectClassName: "noon-form-parent-select",
      childSelectClassName: "noon-form-children-select",
    };
  },
  watch: {
    selectedValue: {
      handler(val) {
        if (!val) {
          let payload = {
            id: this.form.id,
            label: "",
            value: "",
            isAlert: false,
          };
          this.$emit("setValue", payload);
        } else {
          let ids = val.split("-");
          if (ids.length === 1) {
            let op = this.getOption(ids[0], null);
            if (!op.parent) {
              let payload = {
                id: this.form.id,
                label: "",
                value: "",
                isAlert: false,
              };
              this.$emit("setValue", payload);
              return;
            }

            let payload = {
              id: this.form.id,
              label: op.parent.label,
              value: op.parent.id,
              isAlert: op.parent.isAlert,
            };
            this.$emit("setValue", payload);
          } else {
            let op = this.getOption(ids[0], ids[1]);
            let payload = {
              id: this.form.id,
              label: `${op.parent.label} ${op.child.label}`,
              value: op.child.id.split("-")[1],
              parent_value: op.parent.id,
              isAlert: op.child.isAlert,
            };
            this.$emit("setValue", payload);
          }
        }
      },
    },
  },
  components: {
    Treeselect,
  },
  methods: {
    getOption(pid, cid) {
      const parentOption = this.options.find(({ id }) => id === pid);

      if (!parentOption) {
        return {
          parent: null,
          children: null,
        };
      }

      if (parentOption.children) {
        let childOption = parentOption.children.find(
          ({ id }) => id === `${pid}-${cid}`
        );
        return {
          parent: parentOption,
          child: childOption,
        };
      } else {
        return {
          parent: parentOption,
          child: null,
        };
      }
    },
    initInputValue() {
      if (!this.value) {
        const selectedOption = this.form.select_options.find(
          item => item.value === this.form.default_value
        );
        this.inputValue = {
          children: null,
          parent: selectedOption,
        };
        this.setSelectedModel();
        return;
      }

      if (this.value.parent_value) {
        const selectedOption = this.form.select_options.find(
          item => item.value === this.value.parent_value
        );

        this.inputValue = {
          parent: selectedOption,
          children: selectedOption.children
            ? selectedOption.children.find(
                item => item.value === this.value.value
              )
            : null,
        };
        this.setSelectedModel();
        return;
      }

      const selectedOption = this.form.select_options.find(
        item => item.value === this.value.value
      );
      this.inputValue = {
        parent: selectedOption,
        children: null,
      };
      this.setSelectedModel();
    },

    setSelectedModel() {
      if (!this.inputValue.parent) return;
      this.parentSelected = this.form.select_options.find(
        item => item.value === this.inputValue.parent.value
      );
      if (
        !this.parentSelected ||
        !this.parentSelected.children ||
        !this.inputValue.children
      )
        return;
      this.childSelected = this.parentSelected.children.find(
        item => item.value === this.inputValue.children.value
      );
    },

    setOptions() {
      this.form.select_options.forEach(parentEl => {
        let option = {
          id: parentEl.value,
          label: parentEl.label,
          isAlert: parentEl.is_alert,
        };
        if (parentEl.children) {
          let children = [];
          parentEl.children.forEach(el => {
            children.push({
              id: `${parentEl.value}-${el.value}`,
              label: el.label,
              isAlert: el.is_alert,
            });
          });
          option["children"] = children;
        }
        this.options.push(option);
      });
    },

    setValue() {
      if (this.value) {
        if (this.value.parent_value) {
          this.selectedValue = `${this.value.parent_value}-${this.value.value}`;
        } else {
          this.selectedValue = `${this.value.value}`;
        }
      }
    },
  },

  mounted() {
    this.setOptions();
    this.setValue();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-form-hierarchical-select {
  .vue-treeselect div,
  .vue-treeselect span {
    font-size: 1.2rem !important;
  }
  .vue-treeselect__single-value {
    padding: 0.6rem !important;
  }

  .vue-treeselect__control {
    height: 49px !important;
  }
}
</style>
